module.exports = __webpack_public_path__ + "static/media/power-of-thor-megaways.02a74707.gif";